import { merchantIdentifiers, MessagingPlacementsOrder } from '@MerchantConfigurator/constants';

//This is to ensure we order the placements as per design regardles of how they are ordered in the placements input.
export const sortPlacements = (placements) => {
  return MessagingPlacementsOrder.filter((placement) => {
    return placements.includes(placement);
  });
};

export const getMerchantIdType = (merchantIdentifier) => {
  if (merchantIdentifier.length === 13) {
    return merchantIdentifiers.PAYER_ID;
  }
  return merchantIdentifiers.CLIENT;
};
